// LoginPage.js
import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Typography } from 'antd';
import '../CSSfiles/LoginPage.css'; // Import custom CSS file for styling
import logo from '../images/talent-icon.png'; // Import custom image
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import { fetchData } from "../fetch";
import { useAppContext } from './AppContext';
import apteanLogo from '../images/Aptean Logo - Black.svg';
import { set } from 'date-fns';

const { Text } = Typography;

const LoginPage = () => {
  const [graphData, setGraphData] = useState(null);
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const { upName, setUpName, mailID, setMailID, setAccessToken, setIsAdmin,setIdToken } = useAppContext();

  useEffect(() => {
    if (isAuthenticated) {
      fetchGraphData();
    }
  }, [isAuthenticated]);

  const fetchGraphData = async () => {
    try {
      //console.log("Fetching Graph Data");

      const response = await instance.acquireTokenSilent({
        scopes: ["User.Read", "User.Read.All"]
      });

      //console.log("response", response);
      //console.log("Access Token: ", response.accessToken);
      //console.log("idtoken", response.idToken);

      // Check for roles in the ID token
      const roles = response.idTokenClaims.roles || [];
      //console.log("Roles", roles);

      if (roles.includes("User.Admin") || roles.includes("User.General")) {
        //console.log("User has required roles");
        if (roles.includes("User.Admin")) {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }

        setAccessToken(response.accessToken);
        setIdToken(response.idToken);
        //console.log("Access Token from context: ", response.accessToken);

        // Access token retrieved successfully, store it in session storage
       

        const graphResponse = await fetchData("https://graph.microsoft.com/v1.0/me", response.accessToken);
        const data = await graphResponse.json();

        setGraphData(data);
        setMailID(data.mail);
        setUpName(data.userPrincipalName);
        //console.log("Mail Id from Context: ", data.mail);
        //console.log("UPN from Context: ", data.userPrincipalName);

        navigate('/home');
      } else {
        //console.log("User does not have required roles");
        navigate('/unauthorized');
      }

    } catch (error) {
      // Handle token acquisition errors
      //console.error('Error acquiring token silently:', error);
    }
  };

  // Function to handle SSO login
  const handleSSOLogin = () => {
    //console.log("SSO login button clicked");
    //console.log("User is authenticated: ", isAuthenticated);
    //console.log("Instance: ", instance);

    if (!isAuthenticated) {
      instance.loginRedirect({
        scopes: ['User.Read', 'User.Read.All']
      });
    }
  };

  return (
    <Row>
      {/* Left Half */}
      <Col span={12}>
        <div style={{ height: '133.3vh', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', margin: 0, padding: 0 }}>
          <img src={logo} alt="Left Half Image" style={{ minWidth: '100%', minHeight: '100%', objectFit: 'cover', margin: 0, padding: 0 }} />
        </div>
      </Col>

      {/* Right Half */}
      <Col span={12}>
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <img src={apteanLogo} alt="Logo" style={{ maxWidth: '25%', marginBottom: '30px' }} />
          <br />
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '30px' }}>Aptean Talent Review</Text>
          <br />
          <br />
          <Button style={{ width: '25%', height: '50px', fontSize: '20px', backgroundColor: 'black', color: 'white' }} onClick={handleSSOLogin}>
            Company Single Sign-On
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default LoginPage;
